import { useSelector } from 'react-redux';
import '../css/app.css'
import '../css/main.css'
import '../css/common.css'
import '../css/payment.css'
import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom"
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";


function Header() {
    const location = useLocation();
    const navigate = useNavigate();

    if (location.pathname === "/urlNotice") return null;

    const goBack = () => navigate(-1);
    const goCart = () => navigate("/urlUserHistory");

    return (
        <header className="urlHeader-bar" role="banner"
            style={{
                gridTemplateColumns: location.pathname === "/" ? "1fr 56px" : "40px 1fr 56px"
            }}>
            {
                location.pathname != "/" && (
                    <button
                        type="button"
                        className="urlHeader-btn urlHeader-back"
                        aria-label="뒤로가기"
                        onClick={goBack}
                    >
                        <ArrowLeft />
                    </button>
                )
            }

            {/* <div className="urlHeader-center" aria-label="타이틀">
                <span className="urlHeader-title">쇼핑</span>
            </div> */}
            <img src='/img/logo.png' style={{ height: "28px", paddingLeft: location.pathname === "/" ? "15px" : "", cursor: "pointer" }}
                onClick={() => navigate('/')} />

            <button
                type="button"
                className="urlHeader-btn urlHeader-cart"
                aria-label="장바구니"
                onClick={goCart}
            >
                <FontAwesomeIcon icon={faBagShopping} className="urlHeader-ico" />
            </button>
        </header>
    );
}

export default Header;